export const convertTimestampSecondsToMs = (timestamp: number | bigint): number => {
  if (typeof timestamp === 'bigint') {
    return Number(timestamp * BigInt(1000));
  }

  return timestamp * 1000;
};

export const getNowTimestamp = () => {
  return new Date().valueOf();
};
